/**
 * Retourportaal - poppedijn.nl/pages/retourneren
 * Bestelling opzoeken -> artikelen en reden kiezen -> retourlabel kopen
 * (Shopify-checkout) -> status volgen. Praat met de poppedijn-api
 * (/api/returns/*). Geen frameworks, zelfde opzet als samen-kopen.js.
 */
(function () {
  'use strict';

  var CFG = window.__RETOUR_CFG || {};
  /* AVG-afweging: deze calls zijn functioneel-noodzakelijk voor een dienst die
     de klant zelf aanvraagt (retour). Geen tracking, geen consent-gate. */
  var API = CFG.apiBase || window.POPPEDIJN_API_BASE || 'https://poppedijn-api-production.up.railway.app';
  var API_TIMEOUT_MS = 12000;
  var STORAGE_KEY = 'pp_retour_token';
  var POLL_MS = 8000;
  var POLLING_STATUSES = ['betaald', 'label_mislukt'];

  var $page = document.querySelector('[data-retour-page]');
  if (!$page) return;
  var $lookup = $page.querySelector('[data-retour-lookup]');
  var $lookupBtn = $page.querySelector('[data-retour-submit]');
  var $error = $page.querySelector('[data-retour-error]');
  var $resume = $page.querySelector('[data-retour-resume]');
  var $resumeLink = $page.querySelector('[data-retour-resume-link]');
  var $order = $page.querySelector('[data-retour-order]');
  var $status = $page.querySelector('[data-retour-status]');

  var state = { lookup: null, credentials: null, pollTimer: null };

  /* ── Helpers ─────────────────────────────── */
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function carrierName(data) {
    return (data && data.carrier_name) || CFG.carrier || 'de vervoerder';
  }
  function formatPrice(n) {
    return '€' + Number(n || 0).toFixed(2).replace('.', ',');
  }
  function formatDate(d) {
    if (!d) return '';
    return new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  function apiFetch(path, opts) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, API_TIMEOUT_MS);
    var options = opts || {};
    if (controller) options.signal = controller.signal;
    return fetch(API + path, options).then(function (res) {
      clearTimeout(timer);
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          var err = new Error(body.error || 'Er ging iets mis. Probeer het opnieuw.');
          err.status = res.status;
          throw err;
        }
        return body;
      });
    }, function (err) {
      clearTimeout(timer);
      throw new Error(err && err.name === 'AbortError'
        ? 'De verbinding duurde te lang. Probeer het zo nog eens.'
        : 'We konden geen verbinding maken. Controleer je internet en probeer het opnieuw.');
    });
  }
  function postJson(path, body) {
    return apiFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function showError(msg) {
    if (!$error) return;
    $error.textContent = msg;
    $error.hidden = !msg;
  }
  function getToken() {
    var fromUrl = new URLSearchParams(window.location.search).get('retour');
    if (fromUrl && /^[a-f0-9]{32}$/.test(fromUrl)) {
      saveToken(fromUrl);
      return fromUrl;
    }
    try { return localStorage.getItem(STORAGE_KEY) || null; } catch (e) { return null; }
  }
  function saveToken(token) {
    try { localStorage.setItem(STORAGE_KEY, token); } catch (e) { /* prive-modus */ }
  }
  function clearToken() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* prive-modus */ }
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', CFG.pageUrl || window.location.pathname);
    }
  }
  function show(el, html) {
    el.innerHTML = html;
    el.hidden = false;
  }
  function hide(el) {
    el.hidden = true;
    el.innerHTML = '';
  }
  function focusHeading(el) {
    var h = el.querySelector('h2');
    if (!h) return;
    h.setAttribute('tabindex', '-1');
    h.focus({ preventScroll: true });
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Stap 1: bestelling opzoeken ─────────── */
  $lookup.addEventListener('submit', function (e) {
    e.preventDefault();
    showError('');
    var orderNumber = $lookup.order_number.value.trim();
    var email = $lookup.email.value.trim();
    var website = $lookup.website ? $lookup.website.value : '';
    if (!orderNumber) return showError('Vul je bestelnummer in. Je vindt het in de bevestigingsmail, bijvoorbeeld 1234.');
    if (!email) return showError('Vul het e-mailadres in waarmee je hebt besteld.');

    $lookupBtn.disabled = true;
    $lookupBtn.textContent = 'Even zoeken...';
    postJson('/api/returns/lookup', { order_number: orderNumber, email: email, website: website })
      .then(function (data) {
        state.lookup = data;
        state.credentials = { order_number: orderNumber, email: email };
        renderOrder(data);
      })
      .catch(function (err) { showError(err.message); })
      .then(function () {
        $lookupBtn.disabled = false;
        $lookupBtn.textContent = 'Bestelling ophalen';
      });
  });

  /* ── Stap 2 en 3: artikelen, reden, samenvatting ─── */
  function renderOrder(data) {
    var eligible = data.items.filter(function (i) { return i.eligible; });
    var reasonOptions = data.reasons.map(function (r) {
      return '<option value="' + esc(r.code) + '">' + esc(r.label) + '</option>';
    }).join('');

    var itemsHtml = data.items.map(function (item, idx) {
      var disabled = !item.eligible;
      var qtyOptions = '';
      for (var q = 1; q <= item.quantity_returnable; q++) {
        qtyOptions += '<option value="' + q + '">' + q + '</option>';
      }
      return '' +
        '<div class="returns-item' + (disabled ? ' returns-item--disabled' : '') + '" data-item="' + esc(item.fulfillment_line_item_id) + '">' +
          '<div class="returns-item__check">' +
            '<input type="checkbox" id="retour-item-' + idx + '" data-item-check' + (disabled ? ' disabled' : '') + ' aria-describedby="retour-item-sub-' + idx + '">' +
          '</div>' +
          (item.image
            ? '<img class="returns-item__image" src="' + esc(item.image) + '" alt="" width="64" height="64" loading="lazy">'
            : '<div class="returns-item__image" aria-hidden="true"></div>') +
          '<div>' +
            '<label class="returns-item__title" for="retour-item-' + idx + '">' + esc(item.title) + '</label>' +
            '<div class="returns-item__sub" id="retour-item-sub-' + idx + '">' +
              (item.variant_title ? esc(item.variant_title) + ' &middot; ' : '') +
              (item.quantity_delivered > 1 ? esc(item.quantity_delivered) + ' stuks geleverd' : '1 stuk geleverd') +
            '</div>' +
            (disabled ? '<div class="returns-item__why">' + esc(item.reason_text) + '</div>' : '') +
            (disabled ? '' :
              '<div class="returns-item__options" data-item-options hidden>' +
                '<div class="returns-portal__field">' +
                  '<label for="retour-qty-' + idx + '">Aantal</label>' +
                  '<select id="retour-qty-' + idx + '" data-item-qty>' + qtyOptions + '</select>' +
                '</div>' +
                '<div class="returns-portal__field">' +
                  '<label for="retour-reason-' + idx + '">Reden</label>' +
                  '<select id="retour-reason-' + idx + '" data-item-reason>' +
                    '<option value="" disabled selected>Kies een reden</option>' + reasonOptions +
                  '</select>' +
                '</div>' +
                '<div class="returns-portal__field returns-portal__field--wide">' +
                  '<label for="retour-note-' + idx + '">Toelichting (niet verplicht)</label>' +
                  '<textarea id="retour-note-' + idx + '" data-item-note maxlength="500" placeholder="Bijvoorbeeld: de doos was al open, of: liever een maat groter"></textarea>' +
                '</div>' +
              '</div>') +
          '</div>' +
        '</div>';
    }).join('');

    var noticeHtml = '';
    if (!data.order.auto_label) {
      noticeHtml = '<div class="returns-portal__notice">Deze bestelling is buiten Nederland en België bezorgd. Je meldt de retour hier gewoon aan; Sanne regelt het retourlabel daarna persoonlijk en mailt je hoe het verder gaat.</div>';
    } else {
      noticeHtml = '<div class="returns-portal__notice">Het retourlabel van ' + esc(carrierName(data)) + ' kost ' + esc(formatPrice(data.label_price)) + ' en betaal je direct met iDEAL. Beschadigd of verkeerd artikel? Kies die reden: Sanne bekijkt je aanvraag dan eerst en het label is gratis.</div>';
    }

    var html = '' +
      '<h2 class="returns-portal__title">Bestelling ' + esc(data.order.name) + '</h2>' +
      '<p class="returns-portal__meta">Besteld op ' + esc(formatDate(data.order.created_at)) + '. ' +
        (eligible.length ? 'Vink aan wat je wilt terugsturen.' : 'Er zijn geen artikelen meer die je kunt terugsturen.') + '</p>' +
      (eligible.length ? noticeHtml : '') +
      '<div class="returns-items">' + itemsHtml + '</div>' +
      (eligible.length ? '<div class="returns-summary" data-summary hidden></div>' : '') +
      '<p class="returns-portal__error" data-order-error role="alert" hidden></p>' +
      '<div class="returns-portal__actions">' +
        (eligible.length ? '<button type="button" class="btn btn--primary" data-order-submit disabled>Kies eerst een artikel</button>' : '') +
        '<a href="#" class="returns-portal__link" data-order-back>Andere bestelling zoeken</a>' +
      '</div>';

    show($order, html);
    hide($status);
    $lookup.hidden = true;
    focusHeading($order);

    $order.querySelector('[data-order-back]').addEventListener('click', function (e) {
      e.preventDefault();
      hide($order);
      $lookup.hidden = false;
      $lookup.order_number.focus();
    });
    if (!eligible.length) return;

    var $summary = $order.querySelector('[data-summary]');
    var $submit = $order.querySelector('[data-order-submit]');
    var $orderError = $order.querySelector('[data-order-error]');

    function selection() {
      var chosen = [];
      $order.querySelectorAll('.returns-item').forEach(function (row) {
        var check = row.querySelector('[data-item-check]');
        if (!check || !check.checked) return;
        chosen.push({
          fulfillment_line_item_id: row.getAttribute('data-item'),
          title: row.querySelector('.returns-item__title').textContent,
          quantity: parseInt(row.querySelector('[data-item-qty]').value, 10) || 1,
          reason: row.querySelector('[data-item-reason]').value,
          note: row.querySelector('[data-item-note]').value.trim()
        });
      });
      return chosen;
    }

    function updateSummary() {
      var chosen = selection();
      $orderError.hidden = true;
      if (!chosen.length) {
        $summary.hidden = true;
        $submit.disabled = true;
        $submit.textContent = 'Kies eerst een artikel';
        return;
      }
      var missingReason = chosen.some(function (c) { return !c.reason; });
      var free = chosen.some(function (c) { return data.free_reasons.indexOf(c.reason) !== -1; });
      var manual = !data.order.auto_label;
      var rows = chosen.map(function (c) {
        return '<div class="returns-summary__row"><span>' + esc(c.quantity) + ' x ' + esc(c.title) + '</span></div>';
      }).join('');
      var totalRow, hint;
      if (manual) {
        totalRow = '<div class="returns-summary__row returns-summary__row--total"><span>Retourlabel</span><span>regelt Sanne</span></div>';
        hint = 'Je ontvangt een e-mail zodra Sanne je aanvraag heeft bekeken.';
      } else if (free) {
        totalRow = '<div class="returns-summary__row returns-summary__row--total"><span>Retourlabel</span><span>gratis</span></div>';
        hint = 'Omdat je een beschadigd of verkeerd artikel meldt, bekijkt Sanne je aanvraag eerst (meestal binnen een werkdag). Daarna krijg je het label per e-mail.';
      } else {
        totalRow = '<div class="returns-summary__row returns-summary__row--total"><span>Retourlabel ' + esc(carrierName(data)) + '</span><span>' + esc(formatPrice(data.label_price)) + '</span></div>';
        hint = 'Na het betalen staat het label binnen een paar minuten in je mail. Het aankoopbedrag van de artikelen krijg je terug zodra het pakket bij ons binnen is.';
      }
      $summary.innerHTML = rows + totalRow + '<div class="returns-summary__hint">' + hint + '</div>';
      $summary.hidden = false;
      $submit.disabled = missingReason;
      $submit.textContent = missingReason ? 'Kies bij elk artikel een reden' : (manual || free ? 'Retour aanmelden' : 'Retourlabel kopen');
    }

    $order.addEventListener('change', function (e) {
      var check = e.target.closest('[data-item-check]');
      if (check) {
        var opts = check.closest('.returns-item').querySelector('[data-item-options]');
        if (opts) opts.hidden = !check.checked;
      }
      updateSummary();
    });
    $order.addEventListener('input', function (e) {
      if (e.target.matches('[data-item-note]')) updateSummary();
    });

    $submit.addEventListener('click', function () {
      var chosen = selection();
      if (!chosen.length) return;
      var otherWithoutNote = chosen.filter(function (c) { return c.reason === 'OTHER' && c.note.length < 3; });
      if (otherWithoutNote.length) {
        $orderError.textContent = 'Bij "Iets anders" helpt een korte toelichting: ' + otherWithoutNote[0].title + '.';
        $orderError.hidden = false;
        return;
      }
      $submit.disabled = true;
      $submit.textContent = 'Even geduld...';
      $orderError.hidden = true;
      postJson('/api/returns', {
        order_number: state.credentials.order_number,
        email: state.credentials.email,
        items: chosen.map(function (c) {
          return { fulfillment_line_item_id: c.fulfillment_line_item_id, quantity: c.quantity, reason: c.reason, note: c.note };
        })
      }).then(function (result) {
        saveToken(result.token);
        if (result.invoice_url) {
          window.location.href = result.invoice_url;
          return;
        }
        showStatus(result.token);
      }).catch(function (err) {
        $orderError.textContent = err.message;
        $orderError.hidden = false;
        $submit.disabled = false;
        updateSummary();
      });
    });
  }

  /* ── Stap 4: status ──────────────────────── */
  function statusBadge(status) {
    var muted = ['afgewezen', 'geannuleerd', 'verlopen'].indexOf(status) !== -1;
    var labels = {
      concept: 'Nog niet betaald', betaald: 'Betaald', wacht_op_sanne: 'In behandeling',
      label_verstuurd: 'Label verstuurd', label_mislukt: 'Label onderweg', handmatig: 'In behandeling',
      onderweg: 'Onderweg', ontvangen: 'Ontvangen', terugbetaald: 'Terugbetaald', afgerond: 'Afgerond',
      afgewezen: 'Afgewezen', geannuleerd: 'Geannuleerd', verlopen: 'Vervallen'
    };
    return '<span class="returns-status__badge' + (muted ? ' returns-status__badge--muted' : '') + '">' + esc(labels[status] || status) + '</span>';
  }

  function renderStatus(s) {
    var items = (s.items || []).map(function (i) {
      return '<div class="returns-status__item"><span>' + esc(i.quantity) + ' x ' + esc(i.title) + (i.variant_title ? ' (' + esc(i.variant_title) + ')' : '') + '</span><span>' + esc(i.reason_label) + '</span></div>';
    }).join('');

    var actions = '';
    if (s.status === 'concept' && s.invoice_url) {
      actions += '<a class="btn btn--primary" href="' + esc(s.invoice_url) + '">Retourlabel betalen (' + esc(formatPrice(s.label_price)) + ')</a>';
    }
    if (s.label_available) {
      actions += '<a class="btn btn--primary" href="' + esc(API + '/api/returns/' + s.token + '/label.pdf') + '" target="_blank" rel="noopener">Retourlabel downloaden</a>';
    }
    if (s.tracking_url) {
      actions += '<a class="btn btn--secondary" href="' + esc(s.tracking_url) + '" target="_blank" rel="noopener">Volg je pakket</a>';
    }

    var extra = '';
    if (s.status === 'label_verstuurd') {
      extra = 'Het label staat ook in je mail. Print het, plak het op het pakket en geef het af bij een afgiftepunt van ' + carrierName(s) + '.';
    } else if (s.status === 'betaald' || s.status === 'label_mislukt') {
      extra = 'Dit duurt meestal minder dan een minuut. Je hoeft deze pagina niet open te houden; het label komt sowieso per e-mail.';
    } else if (s.status === 'wacht_op_sanne' || s.status === 'handmatig') {
      extra = 'Je krijgt een e-mail zodra Sanne je aanvraag heeft bekeken, meestal binnen een werkdag.';
    } else if (s.status === 'ontvangen') {
      extra = 'We betalen het aankoopbedrag binnen 5 werkdagen terug op de manier waarop je hebt betaald.';
    } else if (s.status === 'concept') {
      extra = 'Zodra de betaling binnen is, maken we je retourlabel en mailen we het naar je.';
    }

    var address = '';
    if (['label_verstuurd', 'onderweg', 'handmatig', 'wacht_op_sanne'].indexOf(s.status) !== -1) {
      address = '<p class="returns-status__address">Ons retouradres: Poppedijn, ' + esc(CFG.storeAddress || 'Burgwal 27, 2611 GG Delft') + '</p>';
    }

    return '' +
      '<div class="returns-status">' +
        statusBadge(s.status) +
        '<h2 class="returns-status__title">Retour voor bestelling ' + esc(s.order_name) + '</h2>' +
        '<p class="returns-status__text">' + esc(s.status_text) + (extra ? ' ' + esc(extra) : '') + '</p>' +
        '<div class="returns-status__items">' + items + '</div>' +
        (actions ? '<div class="returns-status__actions">' + actions + '</div>' : '') +
        address +
        '<p class="returns-portal__alt"><a href="#" data-status-new>Nog een retour aanmelden</a></p>' +
      '</div>';
  }

  function showStatus(token) {
    stopPolling();
    apiFetch('/api/returns/' + token)
      .then(function (s) {
        show($status, renderStatus(s));
        hide($order);
        $lookup.hidden = true;
        focusHeading($status);
        $status.querySelector('[data-status-new]').addEventListener('click', function (e) {
          e.preventDefault();
          stopPolling();
          clearToken();
          hide($status);
          $lookup.hidden = false;
          $lookup.order_number.focus();
        });
        if (POLLING_STATUSES.indexOf(s.status) !== -1) {
          state.pollTimer = setTimeout(function () { showStatus(token); }, POLL_MS);
        }
      })
      .catch(function (err) {
        /* Onbekend of verlopen token: gewoon opnieuw beginnen */
        if (err.status === 404) {
          clearToken();
          $lookup.hidden = false;
          return;
        }
        show($status, '<div class="returns-status"><h2 class="returns-status__title">Status even niet beschikbaar</h2><p class="returns-status__text">' + esc(err.message) + '</p><p class="returns-portal__alt"><a href="#" data-status-retry>Opnieuw proberen</a></p></div>');
        $status.querySelector('[data-status-retry]').addEventListener('click', function (e) {
          e.preventDefault();
          showStatus(token);
        });
      });
  }

  function stopPolling() {
    if (state.pollTimer) clearTimeout(state.pollTimer);
    state.pollTimer = null;
  }

  /* ── Start ────────────────────────────────── */
  var existing = getToken();
  if (existing) {
    $lookup.hidden = true;
    showStatus(existing);
  }
  if ($resume && $resumeLink && existing) {
    $resume.hidden = false;
    $resumeLink.addEventListener('click', function (e) {
      e.preventDefault();
      showStatus(existing);
    });
  }
})();
